module.exports = __webpack_public_path__ + "static/media/AmericaFlag.deb7efd1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/AmericaFlag.webp
// module id = 186
// module chunks = 0